export const STORE_TOOLTIP_DATA = 'STORE_TOOLTIP_DATA';
export const DELETE_TOOLTIP_DATA = 'DELETE_TOOLTIP_DATA';
